import { Component, Inject, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialog,
} from "@angular/material/dialog";
import { Router } from "@angular/router";
import { AdminService } from "../../admin/admin-service";
import { AuthService } from "../../services/auth-services.service";
import { MixinFunctionsService } from "../../services/mixin-functions.service";
import { ForgotComponent } from "../forgot/forgot.component";

@Component({
  selector: "app-session-dialog",
  templateUrl: "./session-dialog.component.html",
  styleUrls: ["./session-dialog.component.scss"],
})
export class SessionDialogComponent implements OnInit {
  itemCategory: any;
  form: FormGroup;
  loading = false;
  params: any = {};
  constructor(
    public dialogRef: MatDialogRef<SessionDialogComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private service: AdminService,
    private router: Router,
    public auth: AuthService,

    private mixins: MixinFunctionsService
  ) {}

  ngOnInit(): void {
    this.form = this.initFormGroup();
  }

  initFormGroup(): FormGroup {
    return this.formBuilder.group({
      password: ["", Validators.required],
      // username: ["", Validators.required],
    });
  }

  save() {
    const params = {
      username: this.mixins.currentUser?.email,
      password: this.form.value.password,
      isSessionRestore: true,
      currentUrl: this.router.url,
    };
    this.params.save(params);

    //this.auth.restoreSession(params);
  }

  logout() {
    this.auth.clearSession();
    this.closeDialog();
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
